import { MdlDialogService } from '@angular-mdl/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { find, isNil } from 'lodash';
import { Observable } from 'rxjs';

import { ActivityLogger } from '../activities/activity-logger';
import { ToolBarMenuItem } from './toolbar-menu-item';
import { Settings, UrlBuilder } from '../core';
import { UserStorage } from '../user';

@Injectable()
export class ToolbarMenuContent {

    private static readonly pwmLink = 'forgot-password';

    constructor(
        private readonly settings: Settings,
        private readonly urlBuilder: UrlBuilder,
        private readonly userStorage: UserStorage,
        private readonly dialogService: MdlDialogService,
        private readonly activityLogger: ActivityLogger,
    ) { }

    public getMenuItems(): Observable<ToolBarMenuItem[]> {
        const result = this.userStorage.currentUser.pipe(
            map(currentUser => {
                const menuItems: ToolBarMenuItem[] = [
                    {
                        itemText: 'User Settings',
                        action: () => {
                            this.urlBuilder
                                .esa()
                                .globalPopup()
                                .user(currentUser.metadata.userId)
                                .navigate({ preserveQueryParams: true });
                        },
                        needsDivider: true
                    }
                ];

                if (!isNil(this.settings.emulatedUserId)) {
                    menuItems.push(
                        {
                            itemText: 'Stop User Emulation',
                            action: async () => {
                                await this.activityLogger.logUserEmulationActivity('EndEmulation', this.settings.emulatedUserId);
                                this.urlBuilder.esa().reload();
                            }
                        }
                    );
                }

                menuItems.push(...[
                    {
                        itemText: 'Terms and Conditions',
                        action: () => {
                            this.urlBuilder
                                .esa()
                                .globalPopup()
                                .terms()
                                .navigate({ preserveQueryParams: true });
                        }
                    },
                    {
                        itemText: 'Password Manager',
                        action: async () => {
                            try {
                                this.settings.linksDictionary[ToolbarMenuContent.pwmLink].navigate();
                            } catch (e) { }
                        }
                    },
                    {
                        itemText: 'Logout',
                        action: async () => {
                            try {
                                await this.dialogService.confirm('Are you sure you want to logout?', 'No', 'Yes', 'Logout').toPromise();
                                await this.activityLogger.refreshUserSession();
                                this.urlBuilder
                                    .esa()
                                    .logout()
                                    .navigate({ saveReturnUrl: true });
                            } catch (e) { }
                        }
                    }
                ]);

                return menuItems;
            })
        );

        return result;
    }

    public getMenuItem(itemText: string): Observable<ToolBarMenuItem> {
        return this.getMenuItems()
            .pipe(
                map(items => {
                    const item = find(items, i => i.itemText === itemText);
                    return item;
                })
            );
    }
}
